module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Personalien-5f12ecbfdbda9382f1c6f051d5d1c2ba.jpg";